<template>
  <div id="" class="">
      <el-dialog title="兑换码" :visible.sync="isShowDialog" :before-close="beforeClose" width="80%" top="2%">

        <!-- <common-search :searchList="searchList" @onSearch="onSearch"></common-search> -->
        <common-table 
          :product_list="code_list" 
          :loading="loading" 
          @sort-change="sortChange" 
          @data-change="getMessageByPage"
          :storageName="storageName"
          title="兑换码列表"
          :type="tableType"
          height="650"
          :newCheckHeader="checkedHeaders"
          ></common-table>
        <div style="text-align: right;margin-top:10px">
           <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="pageSizes"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-dialog>
  </div>
</template>
<script>
import EquipmentTableComponent from "@/components/instrument/EquipmentTableComponent.vue";
import SearchComponent from "@/components/instrument/SearchComponent.vue";
export default {
  components: {
    'common-table': EquipmentTableComponent,
    'common-search': SearchComponent
  },
  props:['dialogVisible','batch'],
  watch: {
    dialogVisible(val){
      this.isShowDialog = val;
      if(val){
        this.currentPage=1;
        this.getMessageByPage();
      }
    },
  },
  data() {
    return {
      isShowDialog: false,
      verificationDialogVisible: false,
      loading: false,
      machineList: null,
      machineNO: '',
      name: '',
      verificationValidDate:[],
      currentPage: 1,
      total: 0,
      pageSizes: [10, 20, 50],
      pageSize: 10,
      machine: {},
      equipmentDialogVisible: false,
      dialogTitle: '',
      searchList: {
        newMachineNO: '',name: '',
      },
      tableHandler: [],
      tableType: 'machines',
      storageName: 'checkedHeaders_over',
      code_list: [],
      checkedHeaders: ['批次名称', '兑换码','使用者名称','是否可用'],
    }
  },
  methods:{
    sortChange(val){
      console.log(val)
      this.order = val.order;
      this.getMessageByPage();
    },
    onSearch(){
      this.$commondata.searchObj = this.searchList;
      this.getMessageByPage();
    },
    changeDialogState(val){
      this.verificationDialogVisible = val;
    },
    changeMachine(){
      this.getMessageByPage();
    },

    beforeClose(done){
      this.isShowDialog = false;
      //this.$refs.record_table.setCurrentRow();
      this.$emit('change-state',{isShow: this.isShowDialog,dialog:'codes'});
    },

    async getMessageByPage(cb){
      this.loading = true;

      //let options = this.$util.formatOptions(this.searchList);

      const code_list = await this.$request.get_codes(this.batch.id,this.currentPage,this.pageSize);
      code_list.data.forEach(item => {
        item.batchName = this.batch.batchName
      })
      this.code_list = code_list.data;
      this.total = code_list.total
      
      cb && cb(code_list.total)

      this.loading = false;
    },

    handleSizeChange(val) {
      //console.log(`每页 ${val} 条`);
      this.pageSize = val;
      this.getMessageByPage();
    },

    handleCurrentChange(val) {
      //console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getMessageByPage();
    },

  },
}
</script>

<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/components/dialog/CodesDialog.vue